module.exports = __webpack_public_path__ + "img/beer_id-116.68a922b6.png";